import { useContext, ReactNode, createContext, useState, useEffect } from 'react'

interface MultimediaRef {
  multimediaUri?: string
  sortMedia?: string
}

export interface DescriptionItem {
  sort?: number | null
  text?: string
  notes?: string | null
}

export interface StaticItem {
  sort?: string
  title_hu?: string
  title_en?: string
  description_hu?: DescriptionItem[]
  description_en?: DescriptionItem[]
  type?: string
  typeID?: string
  multimedia?: MultimediaRef[]
}

interface ContextType {
  projectData: StaticItem[]
  galleryData: StaticItem[]
  isLoading: boolean
}

interface Props {
  children: ReactNode
}

const Context = createContext({} as ContextType)

const StaticTextContext = ({ children }: Props) => {
  const [projectData, setProjectData] = useState<StaticItem[]>([])
  const [galleryData, setGalleryData] = useState<StaticItem[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const loadData = async () => {
    try {
      // Load project.json
      const projectDataRaw = await fetch(
        new URL('../staticContent/project.json', import.meta.url).href,
      ).then(res => res.json())
      setProjectData(projectDataRaw)

      // Load gallery.json
      const galleryDataRaw = await fetch(
        new URL('../staticContent/gallery.json', import.meta.url).href,
      ).then(res => res.json())
      setGalleryData(galleryDataRaw)
    } catch (error) {
      console.error('Error loading static content:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    loadData()
  }, [])

  return (
    <Context.Provider
      value={{
        projectData,
        galleryData,
        isLoading,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useStaticText = () => {
  return useContext(Context)
}

export default StaticTextContext
